"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
function pathExt(path) {
    var index = path.lastIndexOf('.');
    if (index >= 0) {
        return path.substr(index + 1);
    }
    return null;
}
exports.pathExt = pathExt;
var pathSeparators = /[\\\/]/;
function baseName(path) {
    return _.last(path.split(pathSeparators).filter(function (x) { return x; }));
}
exports.baseName = baseName;
//# sourceMappingURL=path.js.map